import React, {Component} from 'react';
import {connect} from 'react-redux'
import LineComponent from './LineComponent';
import NameComponent from './NameComponent';
import { Col, Row, Badge } from 'reactstrap';
import TextInputComponent from './TextInputComponent';
import LODComponent from './LODComponent';
import SearchingTitleComponent from './SearchingTitleComponent';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION, GetListObjectAttemptPost_ACTION } from '../Actions/LogisticActions';
import { Routes } from '../Services/API';

class SearchCoursesComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            Code:'',
            SelectedIndex: 0
        }

        this.renderAdder = this.renderAdder.bind(this)
    }

    componentDidMount(){
        this.props.GetCourseAdders()
    }

    render(){
        console.log(this)
        return(
            <div style = {{ flexDirection:'column',display:'flex', alignItems:'center', alignContent:'center', width: '100%', border:1, borderStyle:'solid', borderColor:'#cccccc', borderRadius:10}}>
            <div style = {{ flexDirection:'column',display:'flex', alignItems:'center', alignContent:'center', width: '90%', margin:10}}>
                <Row style = {{width:'100%'}}>
                    <Col xs = {4}>
                        <NameComponent text = "Courses Name/Code" textColor = "black"/>
                    </Col>
                    <Col xs = {4}>
                        <NameComponent text = "Added By" textColor = "black"/>
                    </Col>
                </Row>
                <Row style = {{width:'100%'}}>
                    <Col xs = {4}>
                        <TextInputComponent TextValue = {this.state.Code} UpdateValue = {(v) => this.setState({Code:v.target.value})}/>
                    </Col>
                    <Col xs = {4}>
                        <div className="animated fadeIn" style = {{overflowY:'scroll', height:120}} >
                        {(this.props.IsAddersSearching || this.props.IsAddersSearching == undefined || this.props.GetAddersError)  ? 
                            <SearchingTitleComponent error = {this.props.GetError} onError = {() => this.props.GetCourseAdders()}/>
                                :<div style = {{flexDirection:'column', display:'flex'}}>
                                    {[{Name:'All', Id:-1}, ...this.props.Adders].map((l, i) => this.renderAdder(l, i))}
                                    </div>}
                        </div>
                    </Col>
                </Row>
                <br/>
                <Row style = {{width:'100%'}}>
                    <Col xs = {2} style = {{cursor:'pointer'}} onClick = {() => {
                        this.props.GetCoursesSearch({
                            Code: this.state.Code,
                            AddedBy: this.state.SelectedIndex ? this.props.Adders[this.state.SelectedIndex - 1].Name : ''
                        })
                    }}>
                        <NameComponent text = "Search" textColor = "white" backgroundColor = "#0099cc" />
                    </Col>
                    <Col xs = {1}>
                    </Col>
                    <Col xs = {2} style = {{cursor:'pointer'}} onClick = {() => {
                        this.props.GetCourses()
                    }}>
                        <NameComponent text = {"Get All Courses"} textColor = "white" backgroundColor = "green" />
                    </Col>
                </Row>                
            </div>
            </div>
        )
    }

    renderAdder(LOD, i){
        return(
          <div 
          style = {{border: 1.8 , borderStyle:'dashed', borderColor:this.state.SelectedIndex == i ? 'green' : '#cccccc', marginBottom:20, cursor:'pointer'}}
          onClick = {() => {
            this.setState({SelectedIndex:i})
          }}
          key = {i}
           >
            <div style = {{flexDirection:'column', display:'flex', height:40, margin:3, alignContent:'center', alignItems:'center'}}>
              <NameComponent text = {LOD.Name} textColor = "#0099cc"/>
              
            </div>
          </div>
        )
      }
}

//Constant
const COURSE_ADDERS_SEARCHING_PARAMETER = 'IsCourseAddersSearching'

const COURSE_ADDERS_DATA_PARAMETER = 'CourseAdders'

const COURSE_ADDERS_GET_ERROR_PARAMETER = 'CourseAddersGetError'

const COURSES_SEARCHING_PARAMETER = 'IsCoursesSearching'

const COURSES_DATA_PARAMETER = 'Courses'

const COURSES_GET_ERROR_PARAMETER = 'CoursesGetError'

function MapStateToProps(state) {
    return {
        Adders: state.Query[COURSE_ADDERS_DATA_PARAMETER],
        IsAddersSearching: state.Query[COURSE_ADDERS_SEARCHING_PARAMETER],
        GetAddersError: state.Query[COURSE_ADDERS_GET_ERROR_PARAMETER],
     
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetCourseAdders: () => {dispatch(GetListAttempt_ACTION({
            SearchParameter: COURSE_ADDERS_SEARCHING_PARAMETER,
            DataParameter: COURSE_ADDERS_DATA_PARAMETER,
            GetErrorParameter: COURSE_ADDERS_GET_ERROR_PARAMETER,
            Path: Routes.GetCourseAdders,
    
            [COURSE_ADDERS_SEARCHING_PARAMETER]: true,
            
            [COURSE_ADDERS_DATA_PARAMETER]: [],
    
            [COURSE_ADDERS_GET_ERROR_PARAMETER]: '',
        }))},
        GetCourses: () => {dispatch(GetListAttempt_ACTION({
            SearchParameter: COURSES_SEARCHING_PARAMETER,
            DataParameter: COURSES_DATA_PARAMETER,
            GetErrorParameter: COURSES_GET_ERROR_PARAMETER,
            Path: Routes.GetAllCourses,
    
            [COURSES_SEARCHING_PARAMETER]: true,
            
            [COURSES_DATA_PARAMETER]: [],
    
            [COURSES_GET_ERROR_PARAMETER]: '',
        }))},
        GetCoursesSearch: (values) => {dispatch(GetListObjectAttemptPost_ACTION({
            SearchParameter: COURSES_SEARCHING_PARAMETER,
            DataParameter: COURSES_DATA_PARAMETER,
            GetErrorParameter: COURSES_GET_ERROR_PARAMETER,
            Path: Routes.SearchCourses,
            Body: values,

            [COURSES_SEARCHING_PARAMETER]: true,
            
            [COURSES_DATA_PARAMETER]: [],
    
            [COURSES_GET_ERROR_PARAMETER]: '',
        }))},
        GetFavoriteCourses: () => {dispatch(GetListAttempt_ACTION({
            
        }))}
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(SearchCoursesComponent)